<script setup lang="ts" generic="T">
import { onBeforeMount } from "vue";

export type THorizontalMenuItem = {
  id: string;
  label: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  value?: any;
};

interface IEmits {
  (e: "change", item: THorizontalMenuItem): void;
}

interface IProps {
  menuItems: [THorizontalMenuItem, ...THorizontalMenuItem[]];
  itemWidth?: number | string;
}

const props = defineProps<IProps>();
const emit = defineEmits<IEmits>();

const currentItem = defineModel<THorizontalMenuItem>("modelValue", {
  required: false,
  default: undefined,
});

onBeforeMount(() => {
  if (currentItem.value === undefined) {
    currentItem.value = props.menuItems[0];
  }
});

function handleItemClicked(item: THorizontalMenuItem) {
  currentItem.value = item;
  emit("change", item);
}
</script>

<template>
  <ul class="bg-gray-100 rounded-md flex text-text-secondary p-2 gap-2 w-fit mb-4">
    <li
      v-for="(item, index) of props.menuItems"
      :key="index"
      class="flex flex-1"
    >
      <button
        class="flex flex-1 w-fit whitespace-nowrap justify-center p-2 rounded-md cursor-pointer hover:bg-white hover:text-brand"
        :class="{
          'bg-white text-brand': currentItem.id == item.id,
        }"
        data-test-id="horizontal-menu-item"
        :style="{
          width: props.itemWidth ? `${props.itemWidth}px` : undefined,
        }"
        @click="handleItemClicked(item)"
      >
        <span class="font-medium">
          {{ item.label }}
        </span>
      </button>
    </li>
  </ul>

  <slot :name="currentItem.id" />
</template>
